// © 2023 Amazon Web Services, Inc. or its affiliates. All Rights Reserved.
// This AWS Content is provided subject to the terms of the AWS Customer Agreement available at
// http://aws.amazon.com/agreement or other written agreement between Customer and either
// Amazon Web Services, Inc. or Amazon Web Services EMEA SARL or both.
import * as React from "react";
import HelpPanel from "@awsui/components-react/help-panel";

function ToolsDrawer() {
  return (
    <HelpPanel header={<h2>About Gotham Sports Access</h2>}>
      <div>
        <p>
          Gotham Sports Access Management is a secure, automated workflow for
          managing time-bound elevated access to your cloud environment. It
          integrates with AWS IAM Identity Center and provides approval-based
          access control at scale.
        </p>
        <h4>Key capabilities</h4>
        <ul>
          <li>Request temporary elevated permissions</li>
          <li>Multi-level approval workflows</li>
          <li>Automatic access provisioning and revocation</li>
          <li>Full session auditing via CloudTrail Lake</li>
          <li>Notifications via email (SES) or Slack</li>
        </ul>
        <h4>How access works</h4>
        <ol>
          <li>A user requests elevated access for a specific account and duration</li>
          <li>Designated approvers review and action the request</li>
          <li>If approved, access is granted at the scheduled start time</li>
          <li>Access is automatically revoked when the session expires</li>
        </ol>
        <h4>Need help?</h4>
        <p>
          Contact your administrator or reach out to the platform team for support.
        </p>
      </div>
    </HelpPanel>
  );
}

export default ToolsDrawer;
